
export enum TimeStampModifiers {
    modifierTime = "event-time",
    modifierScore = "event-score",
    modifierDatePeriod = "event-date",
    modifierLiveTime = "event-live-time"
}